import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectSpread from '@babel/runtime-corejs3/helpers/objectSpread';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import clone from '@ianwalter/clone';
import merge from '@ianwalter/merge';

function VuexReset() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _merge = merge({
    trigger: 'reset'
  }, opts),
      ssr = _merge.ssr,
      trigger = _merge.trigger;

  return function (store) {
    // Extract the initial state from the store so that it can be used to reset
    // the store when a trigger mutation is executed.
    var initialState = clone(store.state); // If the Vuex store needs to be hydrated from SSR data, add it to the store
    // after the initialState is set so that initialState isn't polluted with
    // SSR data and the store can be reset cleanly.

    if (ssr) {
      store.replaceState(merge(clone(store.state), ssr));
    }

    store.subscribe(function (mutation, state) {
      if (mutation.type === trigger) {
        var newState = clone(initialState); // Don't reset route module if set.

        if (state.route) {
          newState.route = clone(state.route);
        } // Reset the entire store state.


        store.replaceState(newState);
      } else {
        // Extract the name of the module and mutation.
        var _mutation$type$split = mutation.type.split('/'),
            _mutation$type$split2 = _slicedToArray(_mutation$type$split, 2),
            mod = _mutation$type$split2[0],
            mut = _mutation$type$split2[1];

        if (mut === trigger) {
          // Reset the state for the module containing the mutation.
          store.replaceState(_objectSpread({}, clone(state), _defineProperty({}, mod, clone(initialState[mod]))));
        }
      }
    });

    store.registerModuleState = function (namespace, mod) {
      store.registerModule(namespace, mod);
      initialState[namespace] = clone(mod.state);
    };

    store.unregisterModuleState = function (namespace) {
      store.unregisterModule(namespace);
      delete initialState[namespace];
    };
  };
}

export default VuexReset;
